import { useEffect, useState } from 'react';
import { OrderShipmentModel } from '../../../models/orderShipment';
import { ProductBadgeModel } from '../../../models/productBadge';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import axios from '../../../lib/axios';
import { MASTER_PRODUCT_UPDATE } from '../../../lib/endpoints/product';
import { IMAGE_PRODUCTS_ROOT_URL } from '../../../constants/imageUrl';
import { convertUrlToFile } from '../../../utils/convertUrlToFile';
import { MasterProductModel } from '../../../models/masterProduct';
import { SuppliesMainGroupName } from '../../../models/suppliesMain';
import { SuppliesDivisionModel } from '../../../models/suppliesDivisionModel';
import { SuppliesCategoryProduct } from '../../../models/suppliesCategoryProduct';
import { SuppliesProductSubCategory } from '../../../models/suppliesSubCategory';
import { getAllMasterMainGroup } from '../../../services/masterMainGroup';
import { getAllMasterDivision } from '../../../services/masterDivision';
import { getAllMasterCategory } from '../../../services/masterCatgegory';
import { getAllMasterSubCategory } from '../../../services/masterSubCategory';
interface Props {
  selectedData: MasterProductModel;
  onClose: VoidFunction;
  onRefetchData: (id: string) => Promise<void>;
  setData: any;
}

const useProductFormController = ({
  selectedData,
  onClose,
  onRefetchData,
  setData,
}: Props) => {
  // variables

  const { i18n } = useTranslation('global');

  const [imageMainFile, setImageMainFile] = useState<any>(null);
  const [imageMainToShow, setImageMainToShow] = useState<any>(null);

  const [imageSecondaryFile, setImageSecondaryFile] = useState<any>([]);
  const [imageSecondaryToShow, setImageSecondaryToShow] = useState<any>([]);

  const [errorMessage, setErrorMessage] = useState<string>('');
  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false);
  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);

  const [dataMasterMainGroups, setDataMasterMainGroups] = useState<SuppliesMainGroupName[]>([]);
  const [dataMasterDivisions, setDataMasterDivisions] = useState<SuppliesDivisionModel[]>([]);
  const [dataMasterCategories, setDataMasterCategories] = useState<SuppliesCategoryProduct[]>([]);
  const [dataMasterSubCategories, setDataMasterSubCategories] = useState<
    SuppliesProductSubCategory[]
  >([]);

  const [loading, setLoading] = useState<boolean>(true);

  const [orderShipment, setOrderShipment] = useState<OrderShipmentModel>({
    delivery: false,
    preOrder: false,
    pickUp: false,
  });
  const [productBadge, setProductBadge] = useState<ProductBadgeModel>({
    newProduct: false,
    recommendProduct: false,
  });

  const nameEn = useRef<HTMLInputElement>(null!);
  const nameLa = useRef<HTMLInputElement>(null!);
  const description = useRef<HTMLInputElement>(null!);
  const [linkVideo, setLinkVideo] = useState<string>('');
  // const quantity = useRef<HTMLInputElement>(null!);
  const itemCode = useRef<HTMLInputElement>(null!);
  const packType = useRef<HTMLInputElement>(null!);
  const uomType = useRef<HTMLInputElement>(null!);
  const stockRef = useRef<HTMLInputElement>(null!);
  const qtyPerPackRef = useRef<HTMLInputElement>(null!);
  const [barcode, setBarcode] = useState<string[]>([]);

  const [brand, setBrand] = useState<string>(null!);
  const [masterMainGroup, setMasterMainGroup] = useState<string>('');
  const [masterDivision, setMasterDivision] = useState<string>('');
  const [masterCategory, setMasterCategory] = useState<string>('');
  const [masterSubCategory, setMasterSubCategory] = useState<string>('');
  const [isActiveProduct, setIsActiveProduct] = useState<boolean>(false);

  const onSelectImageMain = (e: any) => {
    const file = e.target.files[0];
    setImageMainFile(file);
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.readyState === 2) {
        setImageMainToShow(reader.result);
      }
    };
    reader.readAsDataURL(file);
    setImageMainToShow(file);
  };

  const onSelectImageSecondary = (e: any, getIndex: number) => {
    const file = e.target.files[0];
    let newImageFile = imageSecondaryFile?.map((item: any, index: number) => {
      if (index === getIndex) {
        return file;
      } else {
        return item;
      }
    });
    if (getIndex === imageSecondaryFile?.length) {
      newImageFile = [...newImageFile, file];
    }
    setImageSecondaryFile(newImageFile);

    const reader = new FileReader();
    reader.onload = () => {
      if (reader.readyState === 2) {
        let newImageUrl = imageSecondaryToShow?.map((item: any, index: number) => {
          if (index === getIndex) {
            return reader.result;
          } else {
            return item;
          }
        });
        if (getIndex === imageSecondaryToShow?.length) {
          newImageUrl = [...newImageUrl, reader.result];
        }
        setImageSecondaryToShow(newImageUrl);
      }
    };
    reader.readAsDataURL(file);
    newImageFile = newImageFile?.map((item: any, index: number) => {
      if (index === getIndex) {
        return file;
      } else {
        return item;
      }
    });
    setImageSecondaryFile(newImageFile);
  };

  const onRemoveSecondaryImage = (getIndex: number) => {
    setImageSecondaryToShow(
      imageSecondaryToShow.filter((item: any, index: number) => index !== getIndex)
    );
    setImageSecondaryFile(
      imageSecondaryFile.filter((item: any, index: number) => index !== getIndex)
    );
  };

  const onAddBarcode = () => {
    if (!barcode[barcode.length - 1]) {
      setErrorMessage('ກະລຸນາເພີ່ມ Barcode ກ່ອນ');
      return;
    }
    setErrorMessage('');
    setBarcode([...barcode, '']);
  };

  const handleBrandChange = (e: any) => {
    setBrand(e.target.value);
  };

  const handleUpdateData = async () => {
    try {
      setLoadingSubmit(true);
      const formData: any = new FormData();

      // Append the input data to the FormData object
      if (masterMainGroup) {
        formData.append('masterMainGroupId', masterMainGroup);
      }
      if (masterDivision) formData.append('masterDivisionNameId', masterDivision);
      if (masterCategory) formData.append('masterProductCategoryId', masterCategory);
      if (masterSubCategory) formData.append('masterProductSubCategoryId', masterSubCategory);
      if (linkVideo) {
        formData.append('linkViedo', linkVideo);
      }

      if (brand) {
        formData.append('brandId', brand);
      }

      // Append the main image file to the FormData object
      if (imageMainFile) {
        formData.append('mainImage', imageMainFile);
      }

      // Append the secondary image files to the FormData object
      if (imageSecondaryFile?.length > 0) {
        imageSecondaryFile.forEach((item: any) => {
          formData.append('secondImages', item);
        });
      } else {
        formData.append('secondImages', []);
      }
      formData.append('productNameEn', nameEn.current.value);
      formData.append('productNameLa', nameLa.current.value);
      formData.append('description', description.current.value);
      formData.append('isActiveStatus', isActiveProduct);
      // formData.append('productNameEn', );
      console.log(`${MASTER_PRODUCT_UPDATE}?id=${selectedData?.id}`);
      console.log(formData);
      const res = await axios.patch(`${MASTER_PRODUCT_UPDATE}?id=${selectedData?.id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        },
      });
      const newProductUpdate = res?.data;
      setData((prevData: MasterProductModel[]) =>
        prevData.map((item) => (item.id === newProductUpdate.id ? newProductUpdate : item))
      );
      onClose();
    } catch (err: any) {
      // console.log('error=', err);
      try {
        setErrorMessage(err.response.data.message);
      } catch (err2) {
        setErrorMessage('Server error please try again later');
      }
    } finally {
      setLoadingSubmit(false);
      setOpenConfirmDialog(false);
    }
  };

  const handleFormValidate = (): boolean => {
    // if (!selectedData?.mainImage && !imageMainFile) {
    //   setErrorMessage('Please select image');
    //   return false;
    // }
    // if (!masterMainGroup) {
    //   setErrorMessage('Please select Main Group');
    //   return false;
    // }
    // if (!masterDivision) {
    //   setErrorMessage('Please select Division');
    //   return false;
    // }
    // if (!masterCategory) {
    //   setErrorMessage('Please select Category');
    //   return false;
    // }
    // if (!masterSubCategory) {
    //   setErrorMessage('Please select Sub Category');
    //   return false;
    // }
    setErrorMessage('');
    return true;
  };

  const handleConfirmDialog = () => {
    handleUpdateData();
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (handleFormValidate()) {
      setOpenConfirmDialog(true);
    }
  };

  const handleSetSelectedData = async () => {
    try {
      setLoading(true);
      itemCode.current.value = selectedData?.itemcode;
      packType.current.value = selectedData?.packType;
      uomType.current.value = selectedData?.uomType;
      nameEn.current.value = selectedData?.productNameEn;
      nameLa.current.value = selectedData?.productNameLa;
      description.current.value = selectedData?.description;
      packType.current.value = selectedData?.packType;
      setLinkVideo(selectedData?.linkViedo);
      setLinkVideo(selectedData?.linkViedo);
      setImageMainToShow(IMAGE_PRODUCTS_ROOT_URL + selectedData?.mainImage?.url);
      setImageSecondaryToShow(
        selectedData?.secondImages?.map((item: any) => IMAGE_PRODUCTS_ROOT_URL + item?.url)
      );
      if (selectedData?.secondImages?.length > 0) {
        try {
          const imageSecondaryFilePromises = selectedData?.secondImages?.map(async (item: any) =>
            convertUrlToFile(IMAGE_PRODUCTS_ROOT_URL + item?.url, item?.fileName)
          );
          const imageSecondaryFile = await Promise.all(imageSecondaryFilePromises);
          setImageSecondaryFile(imageSecondaryFile);
        } catch (err) {}
      }

      setBarcode(selectedData?.barcodes ?? []);
      setMasterMainGroup(selectedData?.masterMainGroupId);
      setMasterDivision(selectedData?.masterDivisionNameId);
      setMasterCategory(selectedData?.masterProductCategoryId);
      setMasterSubCategory(selectedData?.masterProductSubCategoryId);
      setBrand(selectedData?.brandId);
      setIsActiveProduct(selectedData?.isActiveStatus);
      // stockRef.current.value = selectedData?.stock?.quantity.toString();

      // qtyPerPackRef.current.value = selectedData?.stock?.qtyPerPack.toString();
      await handleGetData();
    } catch (err) {
      console.log(err);
      // console.log('error=', err);
    } finally {
      setLoading(false);
    }
  };

  const handleGetData = async () => {
    const newMasterMainGroup = await getAllMasterMainGroup();
    setDataMasterMainGroups(newMasterMainGroup);

    const newMasterDivision = await getAllMasterDivision();
    setDataMasterDivisions(newMasterDivision);

    const newMasterCategory = await getAllMasterCategory();
    setDataMasterCategories(newMasterCategory);

    const newMasterSubCategory = await getAllMasterSubCategory();
    setDataMasterSubCategories(newMasterSubCategory);
  };

  // useEffect
  useEffect(() => {
    if (selectedData) {
      handleSetSelectedData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedData, i18n]);

  return {
    imageMainFile,
    imageMainToShow,
    onSelectImageMain,
    imageSecondaryToShow,
    onSelectImageSecondary,
    onRemoveSecondaryImage,
    description,
    linkVideo,
    orderShipment,
    onOrderShipmentChange: (newValue: OrderShipmentModel) => setOrderShipment(newValue),
    productBadge,
    onProductBadgeChange: (newValue: ProductBadgeModel) => setProductBadge(newValue),
    barcode,
    onBarcodeChange: (newValue: string[]) => setBarcode(newValue),
    onAddBarcode,
    errorMessage,
    nameEn,
    nameLa,
    handleChangeVideLink: (newValue: string) => setLinkVideo(newValue),
    // quantity,
    itemCode,
    packType,
    uomType,
    masterMainGroup,
    masterDivision,
    masterCategory,
    masterSubCategory,
    handleMasterMainGroupChange: (e: any) => {
      setMasterMainGroup(e.target.value);
      setMasterDivision(null!);
      setMasterCategory(null!);
      setMasterSubCategory(null!);
    },
    handleMasterDivisionChange: (e: any) => {
      setMasterDivision(e.target.value);
      setMasterCategory(null!);
      setMasterSubCategory(null!);
    },
    handleMasterCategoryChange: (e: any) => {
      setMasterCategory(e.target.value);
      setMasterSubCategory(null!);
    },
    handleMasterSubCategoryChange: (e: any) => setMasterSubCategory(e.target.value),
    handleBrandChange,
    brand,
    openConfirmDialog,
    loadingSubmit,
    handleSetOpenConfirmDialog: (newValue: boolean) => setOpenConfirmDialog(newValue),
    handleConfirmDialog,
    handleSubmit,
    loading,
    stockRef,
    qtyPerPackRef,
    dataMasterMainGroups,
    dataMasterDivisions,
    dataMasterCategories,
    dataMasterSubCategories,
    isActiveProduct,
    handleActiveProduct: (newValue: boolean) => setIsActiveProduct(newValue),
  };
};
export default useProductFormController;
